/*
 * CUSTOM:AQARA-HK  custom-compare-groups.js
 * --------------------------------------------------------------------------
 * Restricts the collection-page "比較 / Compare" feature in two ways:
 *
 *   1. Only the models listed in COMPARE_GROUPS below show a 比較 button.
 *      (Any other lock — U200, batteries, NFC card, etc. — has no button.)
 *
 *   2. You can only compare models that belong to the SAME group.
 *      e.g. selecting A100 (deadbolt) then U100 (rim) is blocked.
 *
 * To add / remove a comparable model, OR move one between groups, just edit
 * the handle lists in COMPARE_GROUPS. Nothing else needs to change.
 *
 * This file works alongside (and on top of) assets/custom-compare.js, which
 * is left untouched. It is loaded from layout/theme.liquid right after it.
 * --------------------------------------------------------------------------
 */
(function () {
  'use strict';

  // === EDIT HERE: the two comparison groups, keyed by product handle ===
  var COMPARE_GROUPS = {
    // Group 1 — 門鎖 (deadbolt locks): A100 / D100 / D200i
    'lock-deadbolt': [
      'smart-door-lock-a100-zigbee',
      'smart-door-lock-d100-zigbee',
      'smart-door-lock-d200i'
    ],
    // Group 2 — 輔助鎖 / 附加鎖 (rim locks): U100 / U300 / U400
    'lock-rim': [
      'smart-door-lock-u100',
      'smart-door-lock-u100-hub-e1-set-hidden-item',
      'smart-door-lock-u300-matter',
      'smart-door-lock-u400-matter'
    ],
    // Group 3 — 人體 / 動作 / 存在傳感器 (motion & presence sensors): P1 / P2 / FP1E / FP2 / FP300
    'sensor-human': [
      'sensor-motion-sensor-p1',
      'sensor-motion-and-light-sensor-p2-matter',
      'sensor-presence-sensor-fp1e',
      'sensor-presence-sensor-fp2',
      'sensor-presence-multi-sensor-fp300'
    ],
    // Group 4 — 網關 (hubs, in the Hub collection): E1 / M100 / M200 / M3 / M2 / M2 PoE / Smart Wall Hub V1
    'hub-gateway': [
      'hub-m2',
      'hub-m2-poe',
      'hub-m3-matter',
      'hub-e1',
      'hub-m100-matter',
      'hub-m200',
      'hub-smart-wall-hub-v1'
    ],
    // Group 5 — 攝錄機網關 / 門鈴 (cameras & doorbells): G2H Pro / G3 / G350 / E1 / G4 / G410 / G400 Select / G5 Pro / G100
    'camera-hub': [
      'camera-hub-g2h-pro',
      'camera-hub-g3',
      'camera-hub-g350',
      'camera-e1',
      'doorbell-g4',
      'doorbell-g410-select',
      'doorbell-g400-select',
      'camera-hub-g5-pro-wifi-poe',
      'camera-g100'
    ],
    // Group 6 — LED 燈帶 (light strips, in the Light collection): T2 / COB T1 / SMD T1 / RGB T1
    // (T1 雙色溫燈帶 replaced by 8mm T2 — T1 is end-of-life / archived)
    'light-strip': [
      'light-8mm-bare-board-led-light-strip-t2-dual-color',
      'light-cob-led-strip-t1',
      'light-smd-led-light-strip-t1',
      'light-led-strip-t1-rgb'
    ],
    // Group 7 — 開關 (switches, in the Smart Switch collection): S1E / S1 Plus / S1 Plus EU / H1 ×2 / H1 20A / Z1 Pro / D1
    'switch': [
      'smart-switch-smart-magic-switch-s1e',
      'smart-switch-magicpad-s1-plus',
      'smart-switch-magicpad-s1-plus-eu',
      'smart-switch-smart-wall-switch-h1-eu-matte-white',
      'smart-switch-smart-wall-switch-h1-eu-gray',
      'smart-wall-switch-h1-champagne-gold-space-gray-h1pro-champagne-gold-space-matte-white',
      'smart-switch-smart-wall-switch-h1-20a',
      'smart-switch-smart-wall-switch-z1-pro',
      'smart-switch-smart-wall-switch-d1-with-neutral'
    ],
    // Group N — 吸頂燈 (ceiling lights): 星雲 H1 / RGB T1 / RGB T1M / L1-350 / 天幕 V1
    'light-ceiling': [
      'light-ceiling-light-h1',
      'light-rgb-ceiling-light-t1',
      'light-rgb-ceiling-light-t1m',
      'light-ceiling-light-l1-350',
      'light-smart-sky-mirror-ceiling-light-v1'
    ],
    // Group 10 — 射燈 / 筒燈 (recessed spotlights & downlights): V1 / T2 Lite / T2 Pro
    // (T2 Lite / T2 Pro not created yet — create the products with these
    //  handles, or update the two lines below to match the real handles.)
    'light-spotlight': [
      'light-spotlight-v1',
      'light-spotlight-t2-lite',
      'light-spotlight-t2-pro'
    ],
    // Group 8 — 窗簾路軌電機 (curtain-track motors): C200 / C4 / C3 / CD-M01D ×2 / B1 / H1 / E1 track / E1 rod
    'curtain-track': [
      'windows-curtain-c200',
      'windows-curtain-c4-curtain-controller-set',
      'windows-curtain-curtain-controller-c3',
      'windows-curtain-curtain-controller-motor-cd-m01d-track',
      'windows-curtain-curtain-controller-motor-cd-m01d-extendable-track',
      'windows-curtain-motor-b1-battery-version',
      'windows-curtain-smart-vertical-blinds-controller-h1',
      'windows-curtain-smart-curtain-driver-e1-track-version',
      'windows-curtain-smart-curtain-driver-e1-rod-version'
    ],
    // Group 9 — 捲簾電機 (roller-shade motors): T1S / SRSC-M01 / roller-lift E1
    'curtain-roller': [
      'windows-curtain-roller-shade-controller-t1s',
      'windows-curtain-curtain-rolling-shutter-motor-srsc-m01',
      'windows-curtain-roller-shade-driver-e1'
    ]
  };

  // Message shown when the shopper tries to mix two different lock types.
  var MISMATCH_MESSAGE = '只能比較同一類型產品';

  // Must match assets/custom-compare.js
  var STORAGE_KEY = 'theme1202_compare_mvp_v1';
  var ADD_SELECTOR = '[data-compare-add]';

  // --- helpers ------------------------------------------------------------
  var HANDLE_TO_GROUP = (function () {
    var map = {};
    Object.keys(COMPARE_GROUPS).forEach(function (g) {
      COMPARE_GROUPS[g].forEach(function (h) { map[h] = g; });
    });
    return map;
  })();

  function groupOf(handle) {
    return handle && Object.prototype.hasOwnProperty.call(HANDLE_TO_GROUP, handle)
      ? HANDLE_TO_GROUP[handle]
      : null;
  }

  function isAllowed(handle) {
    return groupOf(handle) !== null;
  }

  // Same storage scope rule as custom-compare.js (per-collection).
  function storageGroupKey() {
    var parts = window.location.pathname.split('/').filter(Boolean);
    if (parts[0] === 'collections' && parts[1]) return 'collection:' + parts[1];
    return 'global';
  }

  function currentItems() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      var list = parsed && parsed[storageGroupKey()];
      return Array.isArray(list) ? list.filter(function (x) { return x && x.handle; }) : [];
    } catch (e) {
      return [];
    }
  }

  // The group the current selection is locked into (null if empty / unknown).
  function selectionGroup() {
    var items = currentItems();
    for (var i = 0; i < items.length; i += 1) {
      var g = (items[i] && items[i].group) || groupOf(items[i] && items[i].handle);
      if (g) return g;
    }
    return null;
  }

  // --- 1) reveal only allowed buttons ------------------------------------
  // theme.liquid hides every compare button by default; we opt-in the allowed
  // ones by tagging them with [data-cc-allowed].
  function markAllowedButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(ADD_SELECTOR).forEach(function (btn) {
      var handle = (btn.getAttribute('data-compare-handle') || '').trim();
      if (isAllowed(handle)) {
        btn.setAttribute('data-cc-allowed', '');
      } else {
        btn.removeAttribute('data-cc-allowed');
      }
    });
  }

  // --- 2) block cross-group selection (capture phase, before the main JS) --
  function onCaptureClick(event) {
    var btn = event.target.closest ? event.target.closest(ADD_SELECTOR) : null;
    if (!btn) return;

    var handle = (btn.getAttribute('data-compare-handle') || '').trim();

    // Safety net: a non-listed model should never be addable.
    if (!isAllowed(handle)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    var items = currentItems();
    var alreadySelected = items.some(function (x) { return x.handle === handle; });
    if (alreadySelected) return; // clicking again = remove, always allowed

    var existing = selectionGroup();
    var incoming = groupOf(handle);
    if (existing && incoming && existing !== incoming) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showToast(MISMATCH_MESSAGE);
    }
  }

  // --- toast (reuses .cc-toast styling from custom-compare.css) -----------
  var toastEl = null;
  var toastTimer = null;
  function showToast(message) {
    if (!toastEl) {
      toastEl = document.querySelector('.cc-toast');
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'cc-toast';
        document.body.appendChild(toastEl);
      }
    }
    toastEl.textContent = message;
    toastEl.classList.add('on');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('on'); }, 3000);
  }

  // === EDIT HERE: collections that should NOT show per-card variant pills ===
  // CUSTOM:AQARA-HK 2026-08-04 - on these collection pages the pills (e.g.
  // 45W 圓形 / 55W 圓形 / 135W 長方形, 8W / 12W) are not drawn. Everything the
  // COMPARE engine needs is still wired up first (data-swatch-option-position,
  // data-swatch-option-name and the data-compare-variant-specs script), so
  // 規格對比 can still switch specs per variant - only the visible pill markup
  // is skipped. Add / remove a collection handle to change where they show.
  var NO_VARIANT_PILL_COLLECTIONS = [
    'light',
    'light-track-light',
    'light-strip',
    'light-ceiling-light',
    'light-spotlight-downlight',
    'light-led-bulb',
    'all',
    'all-products'
  ];

  function currentCollectionHandle() {
    var parts = window.location.pathname.split('/').filter(Boolean);
    return (parts[0] === 'collections' && parts[1]) ? parts[1] : '';
  }

  function variantPillsSuppressed() {
    return NO_VARIANT_PILL_COLLECTIONS.indexOf(currentCollectionHandle()) > -1;
  }

  // --- variant selector injection (metafield option_position) ------------
  // For any product card whose compare metafield declares an option_position,
  // inject a labeled variant selector into the card so the compare engine
  // (custom-compare.js) can switch specs + image per variant. Keeps the big
  // product-card.liquid template untouched.
  function ensurePillCss() {
    if (document.getElementById('cc-vsel-css')) return;
    var st = document.createElement('style');
    st.id = 'cc-vsel-css';
    st.textContent = '.cc-vsel{display:flex;gap:6px;flex-wrap:wrap;}' +
      '.cc-vsel__pill{cursor:pointer;margin:0;}' +
      '.cc-vsel__pill input{position:absolute;opacity:0;width:1px;height:1px;}' +
      '.cc-vsel__pill span{display:inline-block;padding:3px 9px;border:1px solid var(--color--gray,rgba(0,0,0,.25));border-radius:6px;font-size:12px;line-height:1.4;}' +
      '.cc-vsel__pill input:checked + span{border-color:var(--color--body,#111);font-weight:500;}';
    document.head.appendChild(st);
  }

  function injectVariantSelectors(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('[data-product-item]');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.__ccVarDone) return;
      var specEl = card.querySelector('script[data-compare-specs]');
      if (!specEl) return;
      var data;
      try { data = JSON.parse(specEl.textContent || '{}'); } catch (e) { return; }
      if (!data || !data.option_position || !data.variants) return;

      var optName = data.option_name || '';
      var vals = [];
      Object.keys(data.variants).forEach(function (k) {
        var v = k.indexOf('::') > -1 ? k.split('::')[1] : k;
        if (vals.indexOf(v) < 0) vals.push(v);
      });
      if (vals.length < 2) return;

      // The engine reads variant specs from script[data-compare-variant-specs], which
      // liquid only emits for native-swatch products. Create it from the compare JSON.
      if (!card.querySelector('script[data-compare-variant-specs]')) {
        var vsScript = document.createElement('script');
        vsScript.type = 'application/json';
        vsScript.setAttribute('data-compare-variant-specs', '');
        vsScript.textContent = specEl.textContent;
        card.appendChild(vsScript);
      }
      card.setAttribute('data-swatch-option-position', String(data.option_position));
      card.setAttribute('data-swatch-option-name', optName);

      // Pills suppressed on this collection: the compare wiring above is done,
      // so stop before drawing any markup and leave the card as the theme
      // rendered it.
      if (variantPillsSuppressed()) {
        card.__ccVarDone = true;
        return;
      }

      var handle = card.getAttribute('data-handle') || ('p' + Math.random().toString(36).slice(2));
      var html = '<div class="swatches--container cc-vsel" role="radiogroup">';
      vals.forEach(function (v, i) {
        var safe = String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\"/g, '&quot;');
        html += '<label class="cc-vsel__pill">' +
          '<input class="swatch--input" type="radio" data-item="radio" name="cc-vsel-' + handle + '" value="' + safe + '"' + (i === 0 ? ' checked' : '') + '>' +
          '<span>' + safe + '</span></label>';
      });
      html += '</div>';

      var wrap = card.querySelector('.product-card--swatches--horizontal-view');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'product-card--swatches--horizontal-view';
        var anchor = card.querySelector('.cc-card-actions') || card.querySelector('.product-card--details') || card;
        anchor.parentNode ? anchor.parentNode.insertBefore(wrap, anchor) : anchor.appendChild(wrap);
      }
      wrap.innerHTML = html;
      wrap.style.setProperty('display', 'block', 'important');

      var colView = card.querySelector('.product-card--swatches--column-view');
      if (colView && colView.parentNode) colView.parentNode.removeChild(colView);

      card.__ccVarDone = true;
    });
    ensurePillCss();
  }

  // --- init ---------------------------------------------------------------
  function init() {
    markAllowedButtons(document);
    injectVariantSelectors(document);

    // Capture phase guarantees this runs before custom-compare.js's
    // document-level (bubble phase) click handler, so we can cancel the add.
    document.addEventListener('click', onCaptureClick, true);

    // Re-tag buttons when the grid changes (AJAX filtering / pagination).
    if (window.MutationObserver) {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            markAllowedButtons(document);
            injectVariantSelectors(document);
            break;
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



/* CUSTOM:AQARA-HK compare-group-footnote — appended block (same in V12.2 / V13.2).
 * Shows a per-family disclaimer at the bottom of the compare sheet.
 * The compare engine wipes [data-cc-table] on every render, so this re-appends
 * idempotently via a MutationObserver. To add a footnote for another family,
 * add an entry with its product handles below. */
(function () {
  'use strict';

  var FOOTNOTES = [
    {
      // 人體 / 動作 / 存在傳感器 (sensor-human group)
      handles: [
        'sensor-motion-sensor-p1',
        'sensor-motion-and-light-sensor-p2-matter',
        'sensor-presence-sensor-fp1e',
        'sensor-presence-sensor-fp2',
        'sensor-presence-multi-sensor-fp300'
      ],
      text: '#感應距離會因安裝位置、環境因素及設定而有所不同'
    }
  ];

  function readItems() {
    try {
      if (window.CompareMvp && typeof window.CompareMvp.readStorage === 'function') {
        var s = window.CompareMvp.readStorage();
        var l = s[window.CompareMvp.getGroup()];
        return Array.isArray(l) ? l : [];
      }
    } catch (e) {}
    try {
      var raw = window.localStorage.getItem('theme1202_compare_mvp_v1');
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      var parts = window.location.pathname.split('/').filter(Boolean);
      var key = (parts[0] === 'collections' && parts[1]) ? 'collection:' + parts[1] : 'global';
      var list = parsed && parsed[key];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function footnoteText() {
    var items = readItems();
    for (var i = 0; i < FOOTNOTES.length; i += 1) {
      for (var j = 0; j < items.length; j += 1) {
        if (items[j] && FOOTNOTES[i].handles.indexOf(items[j].handle) > -1) {
          return FOOTNOTES[i].text;
        }
      }
    }
    return null;
  }

  function ensureCss() {
    if (document.getElementById('cc-footnote-css')) return;
    var st = document.createElement('style');
    st.id = 'cc-footnote-css';
    st.textContent = '.cc-footnote{padding:10px 4px 2px;font-size:12px;line-height:1.5;color:var(--color--gray,#767676);}';
    document.head.appendChild(st);
  }

  function scrubTaglines() {
    // Clean tagline text captured by an older card revision and persisted in
    // localStorage with broken HTML fragments (e.g. "<br", "<span style=...").
    document.querySelectorAll('.cc-product__tagline, .product-card--tagline').forEach(function (el) {
      var t = el.textContent || '';
      var i = t.indexOf('<');
      if (i === -1) return;
      var clean = t.slice(0, i).replace(/\s+$/, '');
      el.textContent = clean;
      if (!clean) el.style.display = 'none';
    });
  }

  // --- self-heal stored items from fresh card data --------------------------
  // The compare engine snapshots specs/tagline into localStorage when a product
  // is added and never re-reads them, so metafield updates don't reach items
  // already in a shopper's selection. On collection pages we re-sync stored
  // items from the freshly rendered cards before the engine initializes.
  function normText(v) {
    if (v == null) return '';
    return String(v).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  }

  function normSpecs(rows) {
    if (!Array.isArray(rows)) return [];
    var out = [];
    for (var i = 0; i < rows.length; i += 1) {
      var r = rows[i];
      if (!r || typeof r !== 'object') continue;
      var name = normText(r.name != null ? r.name : (r.label != null ? r.label : r.key));
      if (!name) continue;
      var val = normText(r.title != null ? r.title : (r.value != null ? r.value : (r.val != null ? r.val : (r.text != null ? r.text : r.content))));
      out.push({ section: normText(r.section) || '', name: name, value: val });
    }
    return out;
  }

  function mergeVariantSpecs(item) {
    if (!item.variantSpecs || !item.selectedSwatchValue || !Array.isArray(item.specs)) return;
    var vs = item.variantSpecs;
    var raw = null;
    var nk = item.swatchOptionName ? item.swatchOptionName + '::' + item.selectedSwatchValue : null;
    if (nk && Object.prototype.hasOwnProperty.call(vs, nk) && vs[nk]) {
      raw = vs[nk];
    } else if (Object.prototype.hasOwnProperty.call(vs, item.selectedSwatchValue) && vs[item.selectedSwatchValue]) {
      raw = vs[item.selectedSwatchValue];
    } else {
      for (var k in vs) {
        if (Object.prototype.hasOwnProperty.call(vs, k) && k.indexOf('::') > -1 && k.endsWith('::' + item.selectedSwatchValue)) {
          raw = vs[k];
          break;
        }
      }
    }
    if (!raw) return;
    var v = normSpecs(raw);
    var map = {};
    for (var i = 0; i < v.length; i += 1) map[v[i].name.toLowerCase()] = v[i];
    var merged = [];
    for (var j = 0; j < item.specs.length; j += 1) {
      var key = item.specs[j].name.toLowerCase();
      if (map[key]) {
        merged.push(map[key]);
        delete map[key];
      } else {
        merged.push(item.specs[j]);
      }
    }
    for (var m in map) {
      if (Object.prototype.hasOwnProperty.call(map, m)) merged.push(map[m]);
    }
    item.specs = merged;
  }

  function storageKeyName() {
    try {
      if (window.CompareMvp && window.CompareMvp.STORAGE_KEY) return window.CompareMvp.STORAGE_KEY;
    } catch (e) {}
    return 'theme1202_compare_mvp_v1';
  }

  function groupKey() {
    try {
      if (window.CompareMvp && typeof window.CompareMvp.getGroup === 'function') return window.CompareMvp.getGroup();
    } catch (e) {}
    var parts = window.location.pathname.split('/').filter(Boolean);
    return (parts[0] === 'collections' && parts[1]) ? 'collection:' + parts[1] : 'global';
  }

  function refreshSpecsFromCards() {
    try {
      var keyName = storageKeyName();
      var raw = window.localStorage.getItem(keyName);
      if (!raw) return;
      var storage = JSON.parse(raw);
      if (!storage || typeof storage !== 'object') return;
      var gk = groupKey();
      var items = storage[gk];
      if (!Array.isArray(items) || !items.length) return;
      var changed = false;
      for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        if (!item || !item.handle) continue;
        var card = document.querySelector('.product-card--root[data-handle="' + item.handle + '"]');
        if (!card) continue;
        var specEl = card.querySelector('script[data-compare-specs]');
        if (!specEl) continue;
        var data;
        try { data = JSON.parse(specEl.textContent || 'null'); } catch (e) { continue; }
        var fresh = null;
        if (Array.isArray(data)) {
          fresh = normSpecs(data);
        } else if (data && typeof data === 'object' && Array.isArray(data.fallback)) {
          fresh = normSpecs(data.fallback);
        }
        if (!fresh || !fresh.length) continue;
        var before = JSON.stringify({ s: item.specs, v: item.variantSpecs, t: item.tagline });
        item.specs = fresh;
        if (data && data.variants) item.variantSpecs = data.variants;
        mergeVariantSpecs(item);
        var btn = card.querySelector('[data-compare-add]');
        if (btn) item.tagline = normText(btn.getAttribute('data-compare-tagline'));
        if (JSON.stringify({ s: item.specs, v: item.variantSpecs, t: item.tagline }) !== before) changed = true;
      }
      if (changed) window.localStorage.setItem(keyName, JSON.stringify(storage));
    } catch (e) {}
  }

  function sync() {
    scrubTaglines();
    var container = document.querySelector('[data-cc-table]');
    if (!container) return;
    var table = container.querySelector('.cc-table');
    var note = container.querySelector('.cc-footnote');
    var text = footnoteText();

    if (!table || !text) {
      if (note) note.remove();
      return;
    }
    if (note && note.textContent === text) return; // idempotent — safe with observers
    if (!note) {
      note = document.createElement('div');
      note.className = 'cc-footnote';
      container.appendChild(note);
    }
    ensureCss();
    note.textContent = text;
  }

  function boot() {
    refreshSpecsFromCards();
    sync();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i += 1) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { sync(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    // Refresh as soon as product cards appear during parsing - this still runs
    // before DOMContentLoaded, so the compare engine's init() reads the
    // refreshed storage rather than a stale snapshot.
    if (window.MutationObserver) {
      var early = new MutationObserver(function () {
        if (document.querySelector('.product-card--root')) refreshSpecsFromCards();
      });
      early.observe(document.documentElement, { childList: true, subtree: true });
      document.addEventListener('DOMContentLoaded', function () { early.disconnect(); });
    }
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
